module.exports = __webpack_public_path__ + "img/049-storm-3.13c7d800.svg";